export default __webpack_public_path__ + "static/media/card-bg.6f355f12.png";